
const sideBar = () => {

    const menus = [
        {
            id: 'Home',
            route: '/',
            title: '',
            icon: 'mdi-home'
        },
        {
            id: 'ViewTasks',    
            route: 'tasks',
            title: 'Tasks',
            icon: 'mdi-clipboard-account',
            active : false
        },
        {
            id: 'MySubmissions',
            route: 'my-submissions',
            title: 'MySubmissions',
            icon: 'mdi-content-save-check',
        },
        {
            id: 'AddSurvey',
            route: 'add-survey',
            title: 'AddSurvey',
            icon: 'mdi-file-document-plus',
        },
        {
            id: 'SurveyList',
            route: 'survey-list',
            title: 'SurveyList',
            icon: 'mdi-clipboard-check',
        },
        {
            id: 'SurveyListShared',
            route: 'survey-listShared',
            title: 'SurveyListShared',
            icon: 'mdi-clipboard-check',
        },
        {
            id: 'ProcessFollowup',
            route: 'followup',
            title: 'ProcessFollowup',
            icon: 'mdi-refresh-circle',
        },
        {
            id: 'Analytics',
            route: 'analytics',
            title: 'Analytics',
            icon: 'mdi-chart-areaspline',
        },
        /*{
            id: 'ExecutiveAnalytics',
            route: 'executive-analytics',
            title: 'ExecutiveAnalytics',
            icon: 'mdi-chart-areaspline',
        },*/
        {
            id: 'Case',
            title: 'Case',
            icon: 'mdi-sitemap',

            children: [
                {
                    id: 'WorkflowDesigner',
                    route: 'workflow-designer',
                    title: 'WorkflowDesigner'
                },
                {
                    id: 'Apps',
                    route: 'apps',
                    title: 'Apps'
                }
            ]
        },
        {
            id: 'ManageELibrary',
            route: 'manage-eLibrary',
            title: 'ManageELibrary'
        },

        {
            id: 'SystemAdmin',
            title: 'SystemAdmin',
            icon: 'mdi-cog',
           
            children: [
                {
                    id: 'ManageOrganization',
                    route: 'manage-organization',
                    title: 'ManageOrganization'
                },
                {
                    id: 'SystemSettings',
                    route: 'system-settings',
                    title: 'SystemSettings'
                },
                /*{
                    id: 'ELibraryCategories',
                    route: 'eLibrary-categories',
                    title: 'ELibraryCategories'
                },*/
                
                {
                    id: 'Dictionary',
                    route: 'dictionary',
                    title: 'Dictionary'
                },
                {
                    id: 'oldData',
                    route: 'oldData',
                    title: 'OldChartData'
                },
                {
                    id: 'municipalitiesData',
                    route: 'municipalitiesData',
                    title: 'MunicipalitiesData'
                },
                {
                    id: 'Lookups',
                    route: 'lookups',
                    title: 'lookups'
                },
                {
                    id: 'Roles',
                    route: 'roles',
                    title: 'Roles'
                },
                {
                    id: 'QuestionDropDown',
                    route: 'QuestionDropDown',
                    title: 'QuestionDropDown'
                },
                {
                    id: 'QuestionsBank',
                    route: 'QuestionsBank',
                    title: 'QuestionsBank'
                },
                {
                    id: 'EmailTemplates',
                    route: 'EmailTemplates',
                    title: 'EmailTemplates'
                },
                {
                    id: 'AuditTrail',
                    route: 'audit-trail',
                    title: 'AuditTrail'
                },
                {
                    id: 'Municipalities',
                    route: 'Municipalities',
                    title: 'Municipalities'
                },
                {
                    id: 'EmailAuditList',
                    route: 'EmailAuditList',
                    title: 'EmailAuditList'
                }
            ]
        },
    ]



    return menus

}

export default sideBar

